<template>
    <div>
        <main-layout>
            <div class="tabMenu">
                <div class="title">
                    <img src="../assets/img/settings.svg" class="iconMark"> E1 BI Admin
                </div>
            </div>
    
            <div class="AdminContent">
                <el-tabs type="border-card">
                    <el-tab-pane label="Role Permission">
                        <el-row>
                            <el-table :data="RolePermissionData" border style="width: 100%" height="600">
                                <el-table-column fixed prop="RoleCode" label="Role" width="120"></el-table-column>
                                <el-table-column prop="Marketing" label="Marketing" width="120" align="center">
                                    <template scope="scope">
                                        <el-checkbox v-model="scope.row.Marketing"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product Development" label="Product Development" width="170" align="center"></el-table-column>
                                <el-table-column prop="Telemarketing" label="Telemarketing" width="150" align="center"></el-table-column>
                                <el-table-column prop="Academic" label="Academic" width="120" align="center"></el-table-column>
                                <el-table-column prop="Executive" label="Executive" width="120" align="center"></el-table-column>
                                <el-table-column prop="Sales" label="Sales" width="120" align="center"></el-table-column>
                                <el-table-column prop="Admin" label="Admin" width="120" align="center"></el-table-column>
                                <el-table-column prop="Customer Support" label="Customer Support" width="170" align="center"></el-table-column>
                                <el-table-column prop="Cash Accounting" label="Cash Accounting" width="170" align="center"></el-table-column>
                                <el-table-column prop="Operations" label="Operations" width="120" align="center"></el-table-column>
                                <el-table-column prop="Finance" label="Finance" width="120" align="center"></el-table-column>
                            </el-table>
                        </el-row>
                        <el-row>
                            <el-button type="primary" size="large" style="margin: 0 auto; display:table">Save</el-button>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="Subscription">
                        <div>
                            <el-table :data="tableData" border style="width: 100%">
                                <el-table-column prop="SubscriptionName" label="Subscription Name" width="700">
                                </el-table-column>
                                <el-table-column prop="Date" label="Date" width="100">
                                </el-table-column>
                                <el-table-column label="Operation" width="100">
                                    <template scope="scope">
                                        <el-button @click="dialogSubscriptionVisible=true" type="text" size="small">ManageUser</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
    
                    </el-tab-pane>
                    <el-tab-pane label="TMK">Add TMK </el-tab-pane>
                </el-tabs>
            </div>
            <el-dialog title="E1 School Report Subscription" :close-on-click-modal="closeOnClickModal" v-model="dialogSubscriptionVisible" size="large">
                <el-form :model="subForm" :inline="false" label-position="left" label-width="80px">
                    <el-form-item label="Role Name">
                        <el-select v-model="subForm.Role" size="small" placeholder="Please choolse role">
                            <el-option label="All" value="All"></el-option>
                            <el-option label="Administrator" value="Administrator"></el-option>
                            <el-option label="Academic Operation Manager" value="Academic Operation Manager"></el-option>
                            <el-option label="Cashier" value="Cashier"></el-option>
                            <el-option label="Center Manager" value="Center Manager"></el-option>
                            <el-option label="Country Manager" value="Country Manager"></el-option>
                            <el-option label="Director of Studies" value="Director of Studies"></el-option>
                            <el-option label="Finance Controller (FRA)" value="Finance Controller (FRA)"></el-option>
                            <el-option label="Marketing Manager" value="Marketing Manager"></el-option>
                            <el-option label="Regional Director" value="Regional Director"></el-option>
                            <el-option label="Regional Admin" value="Regional Admin"></el-option>
                            <el-option label="Sales Manager" value="Sales Manager"></el-option>
                            <el-option label="Country Support Office  Finance" value="Country Support Office  Finance"></el-option>
                            <el-option label="Telemarketer" value="Telemarketer"></el-option>
                            <el-option label="Worldwide" value="Worldwide"></el-option>
                            <el-option label="Telemarketer Supervisor" value="Telemarketer Supervisor"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Subscribed">
                        <el-radio-group v-model="subForm.Subscribed">
                            <el-radio label="All">All</el-radio>
                            <el-radio label="Yes">Yes</el-radio>
                            <el-radio label="No">No</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="User Name">
                        <el-input v-model="subForm.UserName" size="small" style="width:200px;margin-right:10px" auto-complete="off"></el-input>
                        <el-button type="primary" @click="onSubmit">Search</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="subUserData">
                    <el-table-column property="UserName" label="User Name" width="150"></el-table-column>
                    <el-table-column property="Role" label="Role" width="200"></el-table-column>
                    <el-table-column property="Subscribed" label="Subscribed"></el-table-column>
    
                    <el-table-column label="Operation" width="200">
                        <template scope="scope">
                            <el-button type="text" size="small">Add</el-button>
                            <el-button type="text" size="small">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
    
        </main-layout>
    </div>
</template>
<style scoped>
.AdminContent {
  width: 94.5%;
  padding-left: 28px;
  padding-right: 33px;
  padding-top: 80px;
}
</style>
<script>
import tableau from "tableau-api";
import * as api from "../api";
import config from "../../config";
import MainLayout from "../components/MainLayout.vue";

export default {
  data() {
    return {
      tableData: [
        {
          SubscriptionId: 1,
          SubscriptionName: "E1 School Report Subscription",
          Date: "2017-1-1"
        },
        {
          SubscriptionId: 2,
          SubscriptionName: "E1 Marketing Source Report Subscription",
          Date: "2017-1-1"
        },
        {
          SubscriptionId: 3,
          SubscriptionName: "E1 Weekly Sales Report Subscription",
          Date: "2017-1-1"
        }
      ],
      closeOnClickModal: false,
      dialogSubscriptionVisible: false,
      subForm: {
        Role: "All",
        Subscribed: "Yes",
        UserName: ""
      },
      subUserData: [
        {
          UserName: "bostonharry.ning",
          Role: "Administrator",
          Subscribed: "Yes"
        },
        {
          UserName: "bostonguotao.shan",
          Role: "Administrator",
          Subscribed: "Yes"
        },
        {
          UserName: "bostonkevin2.song",
          Role: "Administrator",
          Subscribed: "Yes"
        },
        {
          UserName: "bostonkevin.wangsh",
          Role: "Administrator",
          Subscribed: "Yes"
        }
      ],
      RolePermissionData: [
        {
          RoleCode: "E1_Admin",
          Marketing: true,
          "Product Development": true,
          Telemarketing: true,
          Academic: true,
          Executive: true,
          Sales: true,
          Admin: true,
          "Customer Support": true,
          "Cash Accounting": true,
          Operations: true,
          Finance: true
        },
        {
          RoleCode: "E1_AOM",
          Marketing: false,
          "Product Development": true,
          Telemarketing: false,
          Academic: true,
          Executive: false,
          Sales: false,
          Admin: false,
          "Customer Support": true,
          "Cash Accounting": false,
          Operations: true,
          Finance: false
        },
        {
          RoleCode: "E1_CA",
          Marketing: false,
          "Product Development": false,
          Telemarketing: false,
          Academic: false,
          Executive: false,
          Sales: false,
          Admin: false,
          "Customer Support": false,
          "Cash Accounting": true,
          Operations: false,
          Finance: true
        },
        {
          RoleCode: "E1_CD",
          Marketing: true,
          "Product Development": false,
          Telemarketing: true,
          Academic: true,
          Executive: true,
          Sales: true,
          Admin: true,
          "Customer Support": true,
          "Cash Accounting": true,
          Operations: true,
          Finance: true
        },
        {
          RoleCode: "E1_CM",
          Marketing: true,
          "Product Development": true,
          Telemarketing: true,
          Academic: true,
          Executive: true,
          Sales: true,
          Admin: true,
          "Customer Support": true,
          "Cash Accounting": true,
          Operations: true,
          Finance: true
        },
        {
          RoleCode: "E1_DS",
          Marketing: false,
          "Product Development": false,
          Telemarketing: false,
          Academic: true,
          Executive: false,
          Sales: false,
          Admin: false,
          "Customer Support": true,
          "Cash Accounting": false,
          Operations: true,
          Finance: false
        },
        {
          RoleCode: "E1_FRAFC",
          Marketing: true,
          "Product Development": true,
          Telemarketing: true,
          Academic: true,
          Executive: true,
          Sales: true,
          Admin: true,
          "Customer Support": true,
          "Cash Accounting": true,
          Operations: true,
          Finance: true
        },
        {
          RoleCode: "E1_MM",
          Marketing: true,
          "Product Development": false,
          Telemarketing: false,
          Academic: false,
          Executive: false,
          Sales: false,
          Admin: false,
          "Customer Support": false,
          "Cash Accounting": false,
          Operations: false,
          Finance: false
        },
        {
          RoleCode: "E1_RAM",
          Marketing: true,
          "Product Development": false,
          Telemarketing: true,
          Academic: true,
          Executive: true,
          Sales: true,
          Admin: true,
          "Customer Support": true,
          "Cash Accounting": true,
          Operations: true,
          Finance: true
        },
        {
          RoleCode: "E1_ReAdmin",
          Marketing: true,
          "Product Development": true,
          Telemarketing: true,
          Academic: true,
          Executive: true,
          Sales: true,
          Admin: true,
          "Customer Support": true,
          "Cash Accounting": true,
          Operations: true,
          Finance: true
        },
        {
          RoleCode: "E1_SM",
          Marketing: false,
          "Product Development": false,
          Telemarketing: false,
          Academic: false,
          Executive: false,
          Sales: true,
          Admin: false,
          "Customer Support": true,
          "Cash Accounting": false,
          Operations: true,
          Finance: false
        },
        {
          RoleCode: "E1_SOF",
          Marketing: false,
          "Product Development": false,
          Telemarketing: false,
          Academic: false,
          Executive: true,
          Sales: false,
          Admin: false,
          "Customer Support": false,
          "Cash Accounting": false,
          Operations: false,
          Finance: true
        },
        {
          RoleCode: "E1_TM",
          Marketing: false,
          "Product Development": false,
          Telemarketing: false,
          Academic: false,
          Executive: false,
          Sales: false,
          Admin: false,
          "Customer Support": false,
          "Cash Accounting": false,
          Operations: false,
          Finance: false
        },
        {
          RoleCode: "E1_TMS",
          Marketing: false,
          "Product Development": false,
          Telemarketing: true,
          Academic: false,
          Executive: false,
          Sales: false,
          Admin: false,
          "Customer Support": false,
          "Cash Accounting": false,
          Operations: false,
          Finance: false
        },
        {
          RoleCode: "E1_WW",
          Marketing: true,
          "Product Development": true,
          Telemarketing: true,
          Academic: true,
          Executive: true,
          Sales: true,
          Admin: true,
          "Customer Support": true,
          "Cash Accounting": true,
          Operations: true,
          Finance: true
        }
      ]
    };
  },
  created: function() {
    document.body.scrollTop = 0;
  },
  mounted: function() {
    if (this.$store.state.accessToken !== "") {
      let path = this.$store.state.route.query.path;
      api.getViz(path).then(
        response => {
          let trustedUrl =
            config.get("TableauServer") + response.body.TrustedUrl;
          var options = {
            usePublishedSize: true,
            toolbarPosition: "top",
            hideToolbar: false
          };
          let viz = new tableau.Viz(
            this.$refs.vizContainer,
            trustedUrl,
            options
          );
          viz.addEventListener("customviewload", function() {
            // document.domain = 'ef.com'
            // viz._impl.$iframe.contentWindow.document.getElementsByClassName('tabToolbarButton tab-widget share')[0].style.display="none"
          });
        },
        response => {
          console.log(response);
        }
      );
    }
  },
  components: {
    MainLayout
  },
  methods: {
    manageUser: function(index) {
      this.$store.commit("switchTab", index);
    },
    onSubmit: function() {}
  }
};
</script>


// WEBPACK FOOTER //
// Admin.vue?27f891a6